import { render, staticRenderFns } from "./site-list-v2.vue?vue&type=template&id=1aabd046&scoped=true&"
import script from "./site-list-v2.vue?vue&type=script&lang=js&"
export * from "./site-list-v2.vue?vue&type=script&lang=js&"
import style0 from "./site-list-v2.vue?vue&type=style&index=0&id=1aabd046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aabd046",
  null
  
)

export default component.exports